<template>
  <div class="all-question-outer">
    <div class="sign" v-if="questionData.data.is_sign == '1'">
      <img src="../../../../assets/cancelSign.png" alt="" />
      <span>已标记</span>
    </div>
    <div class="question" v-if="questionData.data.content">
      <div class="questionTop">
        <span class="title">「问答题」</span>
        <!-- 试题附件展示组件 -->
        <question-files
          v-if="questionData.data.attachment"
          :attachment="questionData.data.attachment"
        ></question-files>
        <span class="questionName"
          >{{ questionData.data.num }}、<span
            v-html="questionData.data.content"
          ></span
        ></span>
      </div>
      <div
        :class="
          questionData.data.user_log.is_right == '1' ? 'answer1' : 'answer2'
        "
      >
        <span>正确答案：</span>
        <div v-if="right" v-html="right"></div>
        <div v-else>无</div>
        <br />
        <span>你的答案：</span><br />
        <div
          v-html="myAnswer"
          v-if="myAnswer.indexOf('ul') != -1"
          class="ul_1"
        ></div>
        <div v-html="myAnswer" v-else class="ol_1"></div>
      </div>
      <div class="ansAnalysis">
        答案解析：
        <div
          v-html="
            questionData.data.correct_content
              ? questionData.data.correct_content
              : '无'
          "
        ></div>
      </div>
      <ul class="show">
        <li v-for="(item, index) in showFileList" :key="index">
          <template v-if="item.type == 'img'">
            <div class="top-box">
                <img :src="item.preview_url" alt="" />
                <div class="preview" @click="showPreview(item, index)">预览</div>
                <a class="preview download" @click="uploadFile(item)">下载</a>
            </div>
            <div class="name">{{ item.name }}</div>
          </template>
          <template v-else-if="item.type == 'doc'">
            <div class="top-box">
                <div class="doc">
                <img src="../../../../assets/word.png" alt="" />
                </div>
                <!-- <div class="preview" @click="showPreview(item, index)">预览</div> -->
                <a class="preview " @click="uploadFile(item)">下载</a>
            </div>
            <div class="name">{{ item.name }}</div>
          </template>
          <template v-else-if="item.type == 'xls'">
            <div class="top-box">
                <div class="xls">
                    <img src="../../../../assets/xls.png" alt="" />
                </div>
                <!-- <div class="preview" @click="showPreview(item,index)">预览</div> -->
                <a class="preview xls" @click="uploadFile(item)">下载</a>
            </div>
            <div class="name">{{ item.name }}</div>
          </template>
          <template v-else-if="item.type == 'ppt'">
            <div class="top-box">
                <div class="ppt">
                <img src="../../../../assets/ppt.png" alt="" />
                </div>
                <!-- <div class="preview" @click="showPreview(item, index)">预览</div> -->
                <a class="preview" @click="uploadFile(item)">下载</a>
            </div>
            <div class="name">{{ item.name }}</div>
          </template>

          <template v-else-if="item.type == 'video'">
            <div class="video">
                <div class="top-box">
                    <div v-if="item.cover" class="video-cover" :style="`background-image:url('${item.cover}')`"></div>
                    <div v-else class="video-tips">转码中</div>
                    <!-- <div class="preview" @click="showPreview(item, index)">预览</div> -->
                    <a class="preview" @click="uploadVideo(item)">下载</a>
                    <!-- <video :src="item.preview_url"></video> -->
                </div>
              <div class="name">{{ item.name }}</div>
            </div>
          </template>

          <template v-else-if="item.type == 'audio'">
            <div class="top-box">
            <div class="audio">
              <img class="audio icon" src="../../../../assets/audio.png" />
            </div>
            <!-- <div class="preview" @click="showPreview(item, index)">预览</div> -->
            <a class="preview" @click="uploadFile(item)">下载</a>
            </div>
            <div class="name">{{ item.name }}</div>
          </template>
        </li>
      </ul>
      <a-modal
        class="previewCombina"
        :visible="previewVisible"
        :footer="null"
        @cancel="handleCancel"
      >
        <div class="previewheader">{{ dialogName }}</div>
        <template>
          <img :src="previewSrc" v-if="fileType == 'img'" />
          <iframe
            :src="previewSrc"
            frameborder="0"
            id="preview"
            v-else
          ></iframe>
        </template>
      </a-modal>
    </div>
    <div class="question" v-else>
      <div class="questionTop">
        <span class="deleted">{{ questionData.data.num }}、此题已被删除</span>
      </div>
      <div class="deleteImg">
        <img src="@/assets/deleted.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import QuestionFiles from "../questionFiles.vue";
import services from '../../../../config/services'
import download from 'downloadjs';
export default {
  name: "quesAnswer",
  props: ["questionData"],
  components: { QuestionFiles },
  data() {
    return {
      //value: this.questionData.user_log?this.questionData.user_log.answer:"",
      right: this.questionData.data.items[0].content,
      myAnswer: "",
      value: null, //输入框评分
      maxScore: parseInt(this.questionData.data.score),
      myScore: 0, //自己的打分
      showFileList: [], //文件列表
      services: services,
      previewVisible: false,
      previewSrc: "", //预览图片路径
      dialogName: "", // 预览的标题
      fileType: "", // 弹框内容类型
    };
  },
  created() {
    if (this.questionData.data.user_log && this.questionData.data.user_log.answer) {
      this.myAnswer = this.questionData.data.user_log.answer;
    } else {
      this.myAnswer = "无";
    }
  },
  mounted () {
    if(this.questionData.data.user_attachment){
      this.showFileList = [...this.questionData.data.user_attachment]
      if (this.showFileList.length > 0) {
        for (let i = 0; i< this.showFileList.length; i++) {
          // status 1 转码中 2转码成功 3转码失败
          let typearr = this.showFileList[i].name.split(".");
          let type = this.judgeType(typearr[typearr.length - 1]);
          this.showFileList[i].type = type
          this.showFileList[i].filename = this.showFileList[i].name
          if(type == 'video'){
            this.showFileList[i].preview_url = this.showFileList[i].file_url
          } else {
            // 其它类型缺少一个 url
            this.showFileList[i].url = this.showFileList[i].file_path;
          }
        }
      }
    } 
  },
  methods: {
    handleCancel () {//关闭预览窗口
      this.previewVisible = false;
    },
    // 预览图片
    showPreview (item, index) {//展示预览
      this.dialogName = ""
      this.dialogName = item.type == "img" ? "图片预览" : item.type == "doc" ? "文档预览" : item.type == "xls" ? "Excel预览" : item.type == "ppt" ? "PPT预览" : item.type == "video" ? "视频预览" : item.type == "audio" ? "音频预览" : ""
      this.fileType = item.type
      if (item.pdf_path) {
        this.previewSrc = item.pdf_path;
        this.previewVisible = true;
      } else {
        this.previewSrc = item.preview_url
        this.previewVisible = true
      }
    },
    // 下载视频方法
    uploadVideo(item){
      fetch(item.preview_url).then(res => res.blob()).then(blob => {
        let newUrl = window.URL.createObjectURL(blob)
        this.createUrlBlob(newUrl, item.filename)
      })
    },
    // 文件流统一处理
    createUrlBlob (url, fileName) {
      const a = document.createElement('a')
      a.style.display = 'none'
      a.href = url
      a.setAttribute('download', fileName);
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    },
    // 下载文件方法
    uploadFile (item) {
      let params = {
        is_download: 1, // 1下载2预览
      }
      if(item.id){
        params.id = item.id
        params.name = item.filename
      } else {
        params.path = item.url
        params.name = item.filename
      }
      services.attachmentFileGet(params).then((res) => {
        // let fileName = item.name.substring(0, item.name.lastIndexOf("."));
        // let format = item.name.substring(item.name.lastIndexOf("."));
        download(res, item.filename, "text/plain");
      })
    },
    judgeType (name) {
      let imgList = ["png", "jpeg", "jpg"];
      let doclist = ["doc", "docx"];
      let xlsList = ["xls", "xlsx"];
      let pptList = ["ppt", "pptx", "pdf"];
      let videoList = ["mp4"]
      let audioList = ["mp3"]
      if (imgList.indexOf(name) != (-1)) {
        return "img";
      } else if (doclist.indexOf(name) != (-1)) {
        return "doc";
      } else if (xlsList.indexOf(name) != (-1)) {
        return "xls";
      } else if (pptList.indexOf(name) != (-1)) {
        return "ppt";
      } else if (videoList.indexOf(name) != (-1)) {
        return "video";
      } else if (audioList.indexOf(name) != (-1)) {
        return "audio";
      }
    },
  }
};
</script>

<style lang="less" scoped>
.all-question-outer {
  width: 100%;
  height: calc(100% - 60px);
  padding: 20px 50px 30px 50px;
  position: relative;
}
.sign {
  height: 32px;
  text-align: right;
  color: #f79e3f;
  position: absolute;
  top: 35px;
  right: 50px;
}
.sign img {
  width: 30px;
  height: auto;
  margin-right: 4px;
  display: inline-block;
}
.sign span {
  line-height: 32px;
}
.question .title {
  width: 371px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 32px;
}
.question .questionName {
  width: 92px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #14202c;
  line-height: 32px;
  word-wrap: break-word;
  word-break: normal;
}
.questionTop {
  width: 100%;
  padding: 15px 0 0;
  /deep/img {
    display: block;
    max-width: 100%;
  }
  /deep/p:first-child {
    display: inline;
  }
  /deep/ol {
    list-style: decimal;
  }
}
li {
  margin-bottom: 20px;
}
li .textarea {
  width: 85%;
}
li span {
  line-height: 32px;
}
.answer1 {
  background: #d7f3ea;
  margin-top: 15px;
  list-style: none;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
.answer1 span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #32b387;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.answer2 {
  background: #fae7e6;
  margin-top: 15px;
  list-style: none;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
.answer2 span {
  width: 79px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ea7e7b;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.answer2 span {
  width: 79px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ea7e7b;
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.answer2 div,
.answer1 div {
  line-height: 40px;
  margin-left: 18px;
  margin-right: 10px;
}
.ansAnalysis {
  margin-top: 21px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 22px;
  word-break: break-all;
  margin-bottom: 40px;
  /deep/img {
    display: block;
    max-width: 100% !important;
  }
}
/deep/p:first-child {
  display: inline;
}
/deep/.ul_1 {
  ul {
    list-style: inside;
  }
}
/deep/.ol_1 {
  ol {
    list-style: auto;
    padding-left: 20px;
  }
}
/deep/.ansAnalysis img {
  max-width: 90% !important;
  display: block;
}
/deep/.ant-radio-wrapper {
  white-space: normal;
}
.deleted {
  color: #ea7e7b;
  font-size: 16px;
}
.deleteImg {
  text-align: center;
  height: 475px;
  margin-top: 140px;
}
ul.show {
  margin-top: 0px;
  display: flex;
  padding-top: 20px;
  li {
    width: 240px;
    margin-right: 25px;
    position: relative;
    .top-box {
      width: 240px;
      height: 135px;
      position: relative;
      overflow: hidden;
    }
    .doc,
    .xls,
    .ppt,
    video {
      background: #e5ecfb;
      width: 240px;
      height: 135px;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
      img {
        width: auto;
        height: auto;
      }
    }
    .video {
      .video-tips {
        width: 240px;
        height: 135px;
        line-height: 135px;
        text-align: center;
        background: #e5ecfb;
        color: #b0b2b8;
        // color: #666666;
      }
      .video-cover {
        width: 240px;
        height: 135px;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .audio {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #eee9ff;
      width: 240px;
      height: 135px;
      .audio.icon {
        width: auto;
        height: auto;
      }
    }
    .ppt {
      background: #ffebea;
    }
    .xls {
      background: #ddffeb;
    }
    img {
      width: 240px;
      height: auto;
    }
    .preview {
      width: 60px;
      height: 30px;
      line-height: 30px;
      background: #2462f5;
      color: #ffffff;
      border-radius: 15px;
      text-align: center;
      position: absolute;
      left: 5px;
      bottom: 5px;
      font-size: 12px;
      z-index: 9;
      cursor: pointer;
    }
    .preview.download.xls {
      left: 5px;
    }
    .preview.download {
      left: 75px;
    }
    .name {
      text-align: center;
      color: #666666;
      font-size: 12px;
      margin-top: 10px;
      word-break: break-all;
      height: auto;
      width: 240px;
    }
  }
}
.previewCombina {
  img {
    margin: 10px;
    max-width: 70%;
  }
  /deep/ .ant-modal {
    width: 85vw !important;
    height: 85vh !important;
  }

  /deep/ .ant-modal-body {
    text-align: center !important;
    padding: 0 !important;
    width: 85vw !important;
    height: 80vh !important;
    audio,
    img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 500px;
    }
  }
  /deep/.ant-modal-close-x {
    width: 30px;
    height: 30px;
  }
  iframe {
    width: 100%;
    height: 100%;
    text-align: center;
    img {
      max-width: 95%;
      max-height: 95%;
    }
  }
}
.previewheader {
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  text-align: left;
  padding-left: 15px;
  padding-right: 15px;
  font-weight: 700;
  background-color: #e5ecfb;
}
/deep/.ant-modal-body img {
  max-width: 75%;
}
</style>
<style>
.ql-container {
  height: 200px !important;
}
</style>